import request from '@/utils/request'
//图片动漫首页 顶部（多张）
export function animation_top(data) {
    return request({
        url: 'api/ad/animation_top',
        method: 'get',
        params: data
    })
}
//  收藏
export function collect_save(data) {
    return request({
        url: 'api/collect/save',
        method: 'post',
        params: data
    })
}
//  取消收藏
export function collect_delete(data) {
    return request({
        url: 'api/collect/delete',
        method: 'post',
        params: data
    })
}
//  是否收藏
export function collect_check(data) {
    return request({
        url: 'api/collect/check',
        method: 'post',
        params: data
    })
}
//  举报分类
export function report_index(data) {
    return request({
        url: 'api/report/index',
        method: 'post',
        params: data
    })
}
//  举报
export function report_save(data) {
    return request({
        url: 'api/report/save',
        method: 'post',
        params: data
    })
}
//  点赞
export function praise_save(data) {
    return request({
        url: 'api/praise/save',
        method: 'post',
        params: data
    })
}
//  取消点赞
export function praise_delete(data) {
    return request({
        url: 'api/praise/delete',
        method: 'post',
        params: data
    })
}
//  是否点赞
export function praise_check(data) {
    return request({
        url: 'api/praise/check',
        method: 'post',
        params: data
    })
}
//评论列表
export function comment_index(data) {
    return request({
        url: 'api/comment/index',
        method: 'post',
        params: data
    })
}
// 回复评论
export function comment_reply(data) {
    return request({
        url: 'api/comment/reply',
        method: 'post',
        params: data
    })
}
//添加评论
export function comment_save(data) {
    return request({
        url: 'api/comment/save',
        method: 'post',
        params: data
    })
}
//小说搜索
export function booksearch(data) {
    return request({
        url: 'api/book/search',
        method: 'post',
        params: data
    })
}
//搜索电影
export function videosearch(data) {
    return request({
        url: 'api/video/search',
        method: 'post',
        params: data
    })
}
//漫画搜索
export function comicsearch(data) {
    return request({
        url: 'api/comic/search',
        method: 'post',
        params: data
    })
}
//社区首页--搜索
export function postsearch(data) {
    return request({
        url: 'api/post/search',
        method: 'post',
        params: data
    })
}
//热门搜索
export function other(data) {
    return request({
        url: 'api/other/search_keyword',
        method: 'post',
        params: data
    })
}


// WEBPACK FOOTER //
// ./src/api/common.js